import { render, staticRenderFns } from "./ImportarCorreosFuncionarios.vue?vue&type=template&id=130cb122"
import script from "./ImportarCorreosFuncionarios.vue?vue&type=script&lang=js"
export * from "./ImportarCorreosFuncionarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports